import { Button } from '@abb/common-ux';
import { requestSiteGetById, requestSitePut } from '@service/siteDataService';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as ActionCreators from '../../actionCreators/licenseAllowanceActionCreators';
import { CustomerSiteModal } from './CustomerSiteModal';

/* tslint:disable:no-empty jsx-no-lambda jsx-self-close*/
export class CustomerSite extends React.Component<any, any> {
      constructor(props: any) {
            super(props);

            this.state = {
                  siteInformationModal: false,
                  servIsSite: undefined
            };
      }

      render() {

            const button = this.props.userPermissions && this.props.userPermissions.isAdmin
            ?  (
                  <div className='col-md-2 text-right align-bottom button-top-buffer'>
                        <Button buttonType='normal' buttonSize='default' icon='plus' onClick={this.handleShowInformationModal}>Update Site</Button>
                  </div>
               )
            : null;
            return (
                  <div>
                        <CustomerSiteModal
                              isOpen={this.state.siteInformationModal}
                              servIsSite={this.state.servIsSite}
                              onClose={this.handleCloseSiteInformationModal}
                              onContinue={this.handleContinueSiteInformationModal}
                        />
                        <div className='container container-style padding-bottom'>
                              <div className='row'>
                                    <div className='col-md-10'>
                                          <div>
                                                <h3>Customer Site</h3>
                                          </div>
                                          <div className='row top-buffer'>
                                                <div className='col-xs-6'>
                                                      <div className='row'>
                                                            <div className='col-xs-2'><b>Site:</b></div>
                                                            <div className='col-xs-4'>{this.props.site && this.props.site.siteName ? this.props.site.siteName : ''}</div>
                                                            <div className='col-xs-2'><b>Owner:</b></div>
                                                            <div className='col-xs-4'>{this.props.site && this.props.site.owner ? this.props.site.owner : ''}</div>
                                                      </div>
                                                </div>
                                                <div className='col-xs-6'>
                                                      <div className='row'>
                                                            <div className='col-xs-2'><b>City:</b></div>
                                                            <div className='col-xs-4'>{this.props.site && this.props.site.city ? this.props.site.city : ''}</div>
                                                            <div className='col-xs-2'><b>Region:</b></div>
                                                            <div className='col-xs-4' style={{ paddingLeft: '40px' }}>{this.props.site && this.props.site.regionName ? this.props.site.regionName : ''}</div>
                                                      </div>
                                                </div>
                                          </div>
                                          <div className='row top-buffer'>
                                                <div className='col-xs-6'>
                                                      <div className='row'>
                                                            <div className='col-xs-2 servis-id-column'><b>ServIS ID:</b></div>
                                                            <div className='col-xs-4'>{this.props.site && this.props.site.servIsId ? this.props.site.servIsId : ''}</div>
                                                            <div className='col-xs-2'><b>Operator:</b></div>
                                                            <div className='col-xs-4'>{this.props.site && this.props.site.operator ? this.props.site.operator : ''}</div>
                                                      </div>
                                                </div>
                                                <div className='col-xs-6'>
                                                      <div className='row'>
                                                            <div className='col-xs-2'><b>Country:</b></div>
                                                            <div className='col-xs-4'>{this.props.site && this.props.site.country ? this.props.site.country : ''}</div>
                                                            <div className='col-xs-2'><b>ServicePorts:</b></div>
                                                            <div className='col-xs-4' style={{ paddingLeft: '40px' }}>{this.props.numberOfSavedServers}</div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                                    <div>
                                          {button}
                                    </div>
                              </div>
                        </div>
                  </div>
            );
      }

      handleContinueSiteInformationModal = async () => {
            await requestSitePut(this.props.site.id, this.props.site.servIsId, this.props.accessToken);
            this.props.updateSite(this.props.site.id, this.props.accessToken);
            this.handleCloseSiteInformationModal();
      }

      handleCloseSiteInformationModal = () => {
            this.setState({ siteInformationModal: false });
      }

      handleShowInformationModal = async () => {
            this.setState({ siteInformationModal: true });
            try {
                  const servIsSite = await requestSiteGetById(this.props.site.servIsId, this.props.accessToken);
                  this.setState({ servIsSite });
            } catch (err) {
                  this.setState({ siteInformationModal: false });
            }
      }

}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomerSite) as any);

export function mapStateToProps(store: any) {
      const { access_token: accessToken } = store.userState.loggedInUser;
      return { ...store.servicesState, ...store.serverState, userPermissions: store.userState.userPermissions, accessToken };
}

function mapDispatchToProps(dispatch: any) {
      return {
            updateSite: (siteId: number, accessToken: string) => dispatch(ActionCreators.onAllocationGetRequest(siteId, accessToken))
      };
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/license/components/SiteLicense/CustomerSite.tsx